<template>
  <div class="content">
    <system :leftList="leftList" />
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>客服管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div class="boxContent">
          <div style="width: 80%; border: 1px solid #ccc">
            <div
              :class="[
                'chat',
                username == 'kefu11' || username == 'kefu99' ? '' : 'noSend',
              ]"
              id="msgBody"
              ref="mianscroll"
              @scroll="handleScroll"
            >
              <div v-for="(item, index) in messageList" :key="index">
                <div class="chatItem" v-if="item.from != user">
                  <div class="userInfo">
                    <div class="chatImg">
                      <img
                        :src="
                          selectUserData.avatar ||
                          require('@/assets/imgs/headImg.png')
                        "
                        alt=""
                      />
                    </div>
                    <div style="margin-left: 10px">
                      <!-- <div>{{ item.from }}</div> -->
                      <div
                        v-if="
                          selectUserData.name &&
                          selectUserData.name != '' &&
                          selectUserData.name != null
                        "
                      >
                        {{ selectUserData.name }}
                      </div>
                      <div v-else>{{ selectUserData.phone | phone }}</div>
                      <div style="margin-top: 10px">{{ item.time }}</div>
                    </div>
                  </div>
                  <div class="userchat">
                    <!-- 文本 -->
                    <div class="box-card" v-if="item.info.type == 0">
                      {{ item.info.context }}
                    </div>
                    <!-- 图片 -->
                    <div
                      class="box-card"
                      v-if="item.info.type == 1"
                      style="background: #fff"
                      @click="handlePictureCardPreview(item.info.context)"
                    >
                      <img :src="item.info.context" alt="" />
                    </div>
                    <!-- 表情 -->
                    <div class="box-card" v-if="item.info.type == 2">
                      {{ item.info.context }}
                    </div>
                    <!-- 视频 -->
                    <div class="box-card" v-if="item.info.type == 3">
                      {{ item.info.context }}
                    </div>
                    <!-- 视频 -->
                    <div class="box-card" v-if="item.info.type == 4">
                      {{ item.info.context }}
                    </div>
                    <!-- 红包 -->
                    <div class="box-card" v-if="item.info.type == 5">
                      {{ item.info.context }}
                    </div>
                    <!-- 地址 -->
                    <div class="box-card" v-if="item.info.type == 6">
                      {{ item.info.address }}
                    </div>
                    <!-- 任务 -->
                    <div
                      v-if="item.info.type == 7"
                      @click="goJob(item.info.id)"
                      class="pointer"
                    >
                      <el-card class="box-card1">
                        <div class="cardTop">
                          <div class="cardNum">
                            任务编号：{{ item.info.jobNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.info.status == 0">待支付</span>
                            <span v-if="item.info.status == 1">待发布</span>
                            <span v-if="item.info.status == 2">发布中</span>
                            <span v-if="item.info.status == 3">已收单</span>
                            <span v-if="item.info.status == 4">实做中</span>
                            <span v-if="item.info.status == 5">已取消</span>
                            <span v-if="item.info.status == 6">已结算</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          地址：{{ item.info.address }}
                        </div>
                        <div style="margin-top: 5px">
                          时间：{{ item.info.jobStart }}-{{ item.info.jobEnd }}
                        </div>
                        <!-- <div class="cardTop" style="margin-top: 5px;">
                          <div class="cardNum">
                            单价：￥{{ item.info.unitPrice }}
                          </div>
                          <div class="cardNum">
                            任务时长：{{ (item.info.hour * 60) | maxTime }}
                          </div>
                          <div class="cardNum">
                            总金额：￥{{ item.info.price }}
                          </div>
                        </div> -->
                      </el-card>
                    </div>
                    <!-- 投诉 -->
                    <div
                      v-if="item.info.type == 8"
                      @click="gocomplaint(item.info.jobComplainId)"
                      class="pointer"
                    >
                      <el-card class="box-card1">
                        <div class="cardTop">
                          <div class="cardNum">
                            投诉编号：{{ item.info.complainNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.info.jobComplainStatus == 0"
                              >未处理</span
                            >
                            <span v-if="item.info.jobComplainStatus == 1"
                              >已处理</span
                            >
                            <span v-if="item.info.jobComplainStatus == 2"
                              >已撤销</span
                            >
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          被投诉人名称：{{ item.info.respondentName }}
                        </div>
                        <div style="margin-top: 5px">
                          投诉人名称：{{ item.info.complainantName }}
                        </div>
                        <div style="margin-top: 5px">
                          投诉原因：{{ item.info.complainMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px">
                          <div class="cardNum">
                            提交时间：{{ item.info.submitAt }}
                          </div>
                          <div class="cardNum">
                            责任人类型：{{
                              item.info.dutyType == 1
                                ? "用户"
                                : item.info.dutyType == 2
                                ? "保安(临勤)"
                                : "保安(公司)"
                            }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 违约 -->
                    <div
                      v-if="item.info.type == 9"
                      @click="godefault(item.info.violateLogId)"
                      class="pointer"
                    >
                      <el-card class="box-card1">
                        <div class="cardTop">
                          <div class="cardNum">
                            违约编号：{{ item.info.violateLogNo }}
                          </div>
                          <div class="cardStatus">
                            {{
                              item.info.violateLogStatus == 0
                                ? "待支付"
                                : "已支付"
                            }}
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          违约类型：{{ item.info.voilateTypeTitle }}
                        </div>
                        <div style="margin-top: 5px">
                          违约规则：{{ item.info.matterMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px">
                          <div class="cardNum">
                            违约：￥{{ item.info.violateAmount }}
                          </div>
                          <div class="cardNum">
                            退还：￥{{ item.info.refundAmount }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 考勤 -->
                    <div
                      v-if="item.info.type == 10"
                      @click="goappeal(item.info.appealId)"
                      class="pointer"
                    >
                      <el-card class="box-card1">
                        <div class="cardTop">
                          <div class="cardNum">
                            考勤申诉编号：{{ item.info.appealNo }}
                          </div>
                          <div class="cardStatus">
                            <span>{{ item.info.operateStatusTitle }}</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          考勤日期：{{ item.info.dueAtIn }}-{{
                            item.info.dueAtOut
                          }}
                        </div>
                        <div style="margin-top: 5px">
                          打卡状态：{{ item.info.signStatusTitle }}
                        </div>
                        <div style="margin-top: 5px">
                          申诉原因：{{ item.info.appealReason }}
                        </div>
                      </el-card>
                    </div>
                  </div>
                </div>
                <div class="chatItem" v-else>
                  <div class="userInfo1">
                    <div style="margin-right: 10px; text-align: right">
                      <div>{{ item.from }}</div>
                      <div style="margin-top: 10px">{{ item.time }}</div>
                    </div>
                    <div class="chatImg">
                      <img src="../../assets/imgs/kefu.png" alt="" />
                    </div>
                  </div>
                  <div class="userchat1">
                    <!-- 文本 -->
                    <div class="box-card other" v-if="item.info.type == 0">
                      {{ item.info.context }}
                    </div>
                    <!-- 图片 -->
                    <div
                      class="box-card other"
                      v-if="item.info.type == 1"
                      style="background: #fff"
                      @click="handlePictureCardPreview(item.info.context)"
                    >
                      <img :src="item.info.context" alt="" />
                    </div>
                    <!-- 表情 -->
                    <div class="box-card other" v-if="item.info.type == 2">
                      {{ item.info.context }}
                    </div>
                    <!-- 视频 -->
                    <div class="box-card other" v-if="item.info.type == 3">
                      {{ item.info.context }}
                    </div>
                    <!-- 视频 -->
                    <div class="box-card other" v-if="item.info.type == 4">
                      {{ item.info.context }}
                    </div>
                    <!-- 红包 -->
                    <div class="box-card other" v-if="item.info.type == 5">
                      {{ item.info.context }}
                    </div>
                    <!-- 地址 -->
                    <div class="box-card other" v-if="item.info.type == 6">
                      {{ item.info.address }}
                    </div>
                    <!-- 任务 -->
                    <div
                      v-if="item.info.type == 7"
                      @click="goJob(item.info.id)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            任务编号：{{ item.info.jobNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.info.status == 0">待支付</span>
                            <span v-if="item.info.status == 1">待发布</span>
                            <span v-if="item.info.status == 2">发布中</span>
                            <span v-if="item.info.status == 3">已收单</span>
                            <span v-if="item.info.status == 4">实做中</span>
                            <span v-if="item.info.status == 5">已取消</span>
                            <span v-if="item.info.status == 6">已结算</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          地址：{{ item.info.address }}
                        </div>
                        <div style="margin-top: 5px">
                          时间：{{ item.info.jobStart }}-{{ item.info.jobEnd }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px">
                          <div class="cardNum">
                            单价：￥{{ item.info.unitPrice }}
                          </div>
                          <div class="cardNum">
                            任务时长：{{ (item.info.hour * 60) | maxTime }}
                          </div>
                          <div class="cardNum">
                            总金额：￥{{ item.info.price }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 投诉 -->
                    <div
                      v-if="item.info.type == 8"
                      @click="gocomplaint(item.info.jobComplainId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            投诉编号：{{ item.info.complainNo }}
                          </div>
                          <div class="cardStatus">
                            <span v-if="item.info.jobComplainStatus == 0"
                              >未处理</span
                            >
                            <span v-if="item.info.jobComplainStatus == 1"
                              >已处理</span
                            >
                            <span v-if="item.info.jobComplainStatus == 2"
                              >已撤销</span
                            >
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          被投诉人名称：{{ item.info.respondentName }}
                        </div>
                        <div style="margin-top: 5px">
                          投诉人名称：{{ item.info.complainantName }}
                        </div>
                        <div style="margin-top: 5px">
                          投诉原因：{{ item.info.complainMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px">
                          <div class="cardNum">
                            提交时间：{{ item.info.submitAt }}
                          </div>
                          <div class="cardNum">
                            责任人类型：{{
                              item.info.dutyType == 1
                                ? "用户"
                                : item.info.dutyType == 2
                                ? "保安(临勤)"
                                : "保安(公司)"
                            }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 违约 -->
                    <div
                      v-if="item.info.type == 9"
                      @click="godefault(item.info.violateLogId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            违约编号：{{ item.info.violateLogNo }}
                          </div>
                          <div class="cardStatus">
                            {{
                              item.info.violateLogStatus == 0
                                ? "待支付"
                                : "已支付"
                            }}
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          违约类型：{{ item.info.voilateTypeTitle }}
                        </div>
                        <div style="margin-top: 5px">
                          违约规则：{{ item.info.voilateMemo }}
                        </div>
                        <div class="cardTop" style="margin-top: 5px">
                          <div class="cardNum">
                            违约：￥{{ item.info.violateAmount }}
                          </div>
                          <div class="cardNum">
                            退还：￥{{ item.info.refundAmount || 0 }}
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <!-- 考勤 -->
                    <div
                      v-if="item.info.type == 10"
                      @click="goappeal(item.info.appealId)"
                      class="pointer"
                    >
                      <el-card class="box-card1 other">
                        <div class="cardTop">
                          <div class="cardNum">
                            考勤申诉编号：{{ item.info.appealNo }}
                          </div>
                          <div class="cardStatus">
                            <span>{{ item.info.operateStatusTitle }}</span>
                          </div>
                        </div>
                        <div style="margin-top: 5px">
                          任务名称：{{ item.info.jobName }}
                        </div>
                        <div style="margin-top: 5px">
                          考勤日期：{{ item.info.dueAtIn }}-{{
                            item.info.dueAtOut
                          }}
                        </div>
                        <div style="margin-top: 5px">
                          打卡状态：{{ item.info.signStatusTitle }}
                        </div>
                        <div style="margin-top: 5px">
                          申诉原因：{{ item.info.appealReason }}
                        </div>
                      </el-card>
                    </div>
                  </div>
                  <div
                    v-if="username == 'kefu11' || username == 'kefu99'"
                    style="
                      text-align: right;
                      color: blue;
                      margin-right: 60px;
                      cursor: pointer;
                    "
                    @click="backInfo(item, index)"
                  >
                    撤回
                  </div>
                </div>
              </div>
            </div>
            <div
              id="msgFooter"
              class="send"
              v-if="username == 'kefu11' || username == 'kefu99'"
            >
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="inputMessage"
                @keyup.enter.native="sendMessage()"
                v-if="sendImg == ''"
                style="margin-right: auto"
              >
              </el-input>
              <img
                v-if="sendImg"
                :src="sendImg"
                class="avatar"
                style="margin-right: auto"
              />
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="deader"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <div class="btn">
                  图片<i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="btn" @click="sendMessage()">发送</div>
            </div>
          </div>
          <div
            style="
              width: 20%;
              overflow-y: scroll;
              min-height: 100%;
              max-height: 78vh;
            "
            v-infinite-scroll="loadUser"
          >
            <div class="listTile">用户列表</div>
            <div
              :class="[
                'userItem',
                selectUserData.memberId == item.memberId ? 'ueserSelect' : '',
              ]"
              v-for="(item, index) in userList"
              :key="index"
              @click="selectUser(item)"
            >
              <div class="userImg">
                <img
                  :src="item.avatar || require('@/assets/imgs/headImg.png')"
                  alt=""
                />
              </div>
              <div style="margin: 0 10px">
                <div v-if="item.name && item.name != '' && item.name != null">
                  {{ item.name }}
                </div>
                <div v-else>{{ item.phone | phone }}</div>
                <div v-if="item.memberType == 1">客户</div>
                <div v-if="item.memberType == 2">临勤</div>
                <div v-if="item.memberType == 3">保安公司</div>
                <div v-if="item.memberType == 4">保安公司员工</div>
              </div>
              <div class="num" v-if="item.unReadNum > 0">
                {{ item.unReadNum > 99 ? "99+" : item.unReadNum }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import websdk from "easemob-websdk";
import { conn } from "../../utils/initWeb.js";
import axiosUrl from "../../api/axios.js";
//格式化时间
// import { renderTime } from "../../utils/index.js";
export default {
  name: "IMChatA",
  components: { system },
  data() {
    return {
      user: "", //自己应用下的用户id
      pwd: "666888", //用户密码
      inputMessage: "",
      messageList: [], //消息
      leftList: this.Plugins.customerData(),
      userList: [],
      selectUserData: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      sendImg: "",
      dialogVisible: false,
      dialogImageUrl: "",
      page: 1,
      pageSize: 10,
      page1: 1,
      pageSize1: 10,
      message: "",
      load: false, // 是否可以加载
      uploadUrl: "",
      username: "",
    };
  },
  created() {
    this.user =
      window.location.hostname == "manager.baoanlailou.com"
        ? "kefu11"
        : "kefu99";
    this.username = localStorage.getItem("USERNAME");
    if (
      localStorage.getItem("USERNAME") == "kefu11" ||
      localStorage.getItem("USERNAME") == "kefu99"
    ) {
      this.getList();
      this.getMessage();
      // this.message = conn.onTextMessage();
      console.log(this.message, "实时收到的消息");
    } else {
      this.getList();
    }
  },
  mounted() {
    // let client = new WebIM.connection({
    //   appKey: WebIM.config.appkey,
    // });
    // if (client.isOpened()) {
    //   this.loginIM();
    // }
    this.loginIM();
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    this.page = 1;
  },
  watch: {
    // message(newValue) {
    //   console.log("触发获取到消息的事件");
    // }
  },
  methods: {
    //撤回消息
    backInfo(item, index) {
      let that = this;
      console.log(index);
      console.log(item, "撤回的消息");
      console.log(that.messageList);
      let option = {
        // 要撤回消息的消息 ID。
        mid: item.id,
        // 消息接收方：单聊为对方用户 ID，群聊和聊天室分别为群组 ID 和聊天室 ID。
        to: item.to,
        // 会话类型：单聊、群聊和聊天室分别为 `singleChat`、`groupChat` 和 `chatRoom`。
        chatType: "singleChat",
        // 撤回消息自定义字段。
        ext: "ext",
      };
      conn
        .recallMessage(option)
        .then((res) => {
          let arr = that.messageList;
          arr.splice(index, 1);
          that.messageList = arr;
          console.log(that.messageList);
          let param = {
            messageId: item.id,
          };
          that.$axios
            .post(`/admapi/im/revokemsg`, param)
            .then(({ data }) => {
              that.$message.success("撤回成功");
              that.$nextTick(() => {
                let scrollEl = that.$refs.mianscroll;
                scrollEl.scrollTo({
                  top: scrollEl.scrollHeight,
                  behavior: "smooth",
                });
              });
            })
            .catch()
            .finally();
        })
        .catch((error) => {
          // 消息撤回失败，原因可能是超过了撤销时限(超过 2 分钟)。
          console.log("fail", error);
          that.$message.error("消息撤回失败，超过了撤销时限(超过 2 分钟)。");
        });
    },
    goappeal(val) {
      let routeUrl = this.$router.resolve({
        path: "/appealDetail",
        query: {
          id: val,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    goJob(val) {
      let routeUrl = this.$router.resolve({
        path: "/taskDetail",
        query: {
          id: val,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    gocomplaint(val) {
      let routeUrl = this.$router.resolve({
        path: "/complaintAdd",
        query: {
          id: val,
          isDetail: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    godefault(val) {
      let routeUrl = this.$router.resolve({
        path: "/defaultDetail",
        query: {
          id: val,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleScroll() {
      const e = this.$refs["mianscroll"];
      const scrollTop = e.scrollTop;
      if (scrollTop == 0 && this.messageList.length != 0) {
        this.page1 += 1;
        this.getInfoList("scroll");
      }
    },
    //上拉加载用户列表
    loadUser() {
      console.log("加载更多用户");
      console.log(this.load);
      if (this.load == true) {
        this.page += 1;
        this.getList();
      }
    },
    // 图品预览
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val;
      this.dialogVisible = true;
    },
    //上传图片
    handleAvatarSuccess(res, file) {
      this.sendImg = res.data;
    },
    //选择聊天的用户
    selectUser(val) {
      this.selectUserData = val;
      this.messageList = [];
      this.page1 = 1;
      this.getInfoList("get");
      this.geted();
    },
    // 获取某用户的消息列表
    getInfoList(val) {
      let param = {
        page: this.page1,
        pageSize: this.pageSize1,
        receiverAccount: this.selectUserData.maniacCode,
        receiverType: this.selectUserData.memberType,
      };
      this.$axios
        .post(`/admapi/im/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          let list = this.messageList;
          for (var i = 0; i < arr.length; i++) {
            let obj = {
              msgType: "text",
              info: arr[i].message.toString(),
              to: arr[i].receiverAccount,
              from: arr[i].senderAccount,
              id: arr[i].messageId,
              time: arr[i].gmtCreate.toLocaleString(),
            };

            list.unshift(obj);
          }
          this.messageList = list;
          this.handleData();
          this.geted();
          if (val == "get") {
            this.$nextTick(() => {
              let scrollEl = this.$refs.mianscroll;
              scrollEl.scrollTo({
                top: scrollEl.scrollHeight,
                behavior: "smooth",
              });
            });
          }
        })
        .catch()
        .finally();
    },
    // 已读消息
    geted() {
      let param = {
        receiverAccount: this.selectUserData.maniacCode,
        receiverType: this.selectUserData.memberType,
      };
      this.$axios
        .post(`/admapi/im/doreadmsg`, param)
        .then(({ data }) => {
          let arr = this.userList;
          let arr1 = [];
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].maniacCode == this.selectUserData.maniacCode) {
              arr[i].unReadNum = 0;
            }
            arr1.push(arr[i]);
          }
          this.userList = arr1;
        })
        .catch()
        .finally();
    },
    // 用户列表
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/im/memberlist`, param)
        .then(({ data }) => {
          let arr = data.items;
          if (data.items.length == 10) {
            this.load = true;
          } else {
            this.load = false;
          }
          let newArr = this.userList;
          for (var i = 0; i < arr.length; i++) {
            newArr.push(arr[i]);
          }
          newArr = this.Plugins.uniqueBy(newArr, "maniacCode");
          this.userList = newArr;
          if (this.selectUserData == "") {
            this.selectUserData = data.items[0];
            this.getInfoList("get");
          }
        })
        .catch()
        .finally();
    },
    //登陆
    loginIM() {
      let that = this;
      var options = {
        user: this.user,
        pwd: this.pwd,
        appKey: WebIM.config.appkey,
        success: function (res) {
          console.log("登录成功");
        },
        error: function (err) {
          console.log(err);
        },
      };
      conn.open(options);
      that.getList();
    },
    //发送消息
    sendMessage() {
      if (
        (!this.inputMessage || !this.inputMessage.replace(/&nbsp;|\s/g, "")) &&
        this.sendImg == ""
      ) {
        this.$message.info("发送内容不能为空!");
        return;
      }
      let messageID = "";
      let that = this;
      let contentMsg = ""; //消息内容
      let toID = that.selectUserData.maniacCode; //收信息用户id
      let id = conn.getUniqueId(); // 生成本地消息id
      let msg = ""; // 创建消息
      if (that.sendImg != "") {
        contentMsg = that.sendImg;
        let option = {
          chatType: "singleChat",
          // 消息类型。
          type: "img",
          // 图片文件的 URL 地址。
          url: contentMsg,
          // 消息接收方：单聊为对方用户 ID，群聊和聊天室分别为群组 ID 和聊天室 ID。
          to: toID,
        };
        // 创建一条图片消息。
        let msg = WebIM.message.create(option);
        //  调用 `send` 方法发送该图片消息。
        conn.send(msg).then((res) => {
          messageID = res.serverMsgId;
          let obj = {};
          obj.type = 1; // 图片消息
          obj.context = contentMsg;
          let param = {
            message: JSON.stringify(obj),
            receiverAccount: toID,
            receiverType: that.selectUserData.memberType,
            receiverId: that.selectUserData.memberId,
            messageId: messageID,
          };
          that.$axios
            .post(`/admapi/im/send`, param)
            .then(({ data }) => {
              let value = {
                msgType: "img",
                info: obj,
                to: toID,
                from: that.user,
                id: messageID,
                time: new Date().toLocaleString(),
              };
              value.time = value.time.replace(/[/]/g, "-");
              let arr = that.messageList;
              arr.push(value);
              that.messageList = arr;
              that.inputMessage = "";
              that.sendImg = "";
              that.$nextTick(() => {
                let scrollEl = that.$refs.mianscroll;
                scrollEl.scrollTo({
                  top: scrollEl.scrollHeight,
                  behavior: "smooth",
                });
              });
            })
            .catch()
            .finally();
        });
        console.log("图片消息发送成功");
        //请求发送消息接口存储到公司数据库
      } else {
        contentMsg = that.inputMessage;
        msg = new WebIM.message("txt", id); // 创建文本消息
        msg.set({
          msg: contentMsg, // 消息内容
          to: toID, // 接收消息对象（用户id）
          chatType: "singleChat", // 设置为单聊
          success: function (id, serverMsgId) {
            console.log("成功发送消息", serverMsgId);
            // that.sendMessageSuccessful(contentMsg, toID, "txt");
            //请求发送消息接口存储到公司数据库
            let obj = {};
            if (that.sendImg == "") {
              obj.type = 0; // 文本消息
              obj.context = contentMsg;
            } else {
              obj.type = 1; // 文本消息
              obj.context = that.sendImg;
            }
            let param = {
              message: JSON.stringify(obj),
              receiverAccount: toID,
              receiverType: that.selectUserData.memberType,
              receiverId: that.selectUserData.memberId,
              messageId: serverMsgId,
            };
            that.$axios
              .post(`/admapi/im/send`, param)
              .then(({ data }) => {
                let value = {
                  msgType: "text",
                  info: obj,
                  to: toID,
                  from: that.user,
                  id: serverMsgId,
                  time: new Date().toLocaleString(),
                };
                value.time = value.time.replace(/[/]/g, "-");
                let arr = that.messageList;
                arr.push(value);
                that.messageList = arr;
                that.inputMessage = "";
                that.sendImg = "";
                that.$nextTick(() => {
                  let scrollEl = that.$refs.mianscroll;
                  scrollEl.scrollTo({
                    top: scrollEl.scrollHeight,
                    behavior: "smooth",
                  });
                });
              })
              .catch()
              .finally();
          },
          fail: function (e) {
            console.log("发送消息失败");
          },
        });
        console.log("发送消息", msg);
        conn.send(msg.body);
      }
    },
    //收到消息，进行消息加入到聊天信息数组中，新的聊天给用户列表添加数据
    saveMessage(val, val1) {
      // val是用户id，val1是消息内容
      // conn.fetchUserInfoById(val).then(res => {
      //   console.log("获取用户信息", res);
      // });
      let hasAdmin = this.userList.some((user) => user.maniacCode == val);
      if (hasAdmin == true) {
        for (var i = 0; i < this.userList.length; i++) {
          if (this.userList[i].maniacCode == val) {
            if (val == this.selectUserData.maniacCode) {
              this.messageList.push(val1);
              this.handleData("new");
              this.geted();
            } else {
              this.userList[i].unReadNum += 1; // 未读消息数加1
              const targetUser = this.userList.splice(i, 1)[0]; // 删除并获取该对象
              // 插入到第一位
              this.userList.unshift(targetUser);
            }
          }
        }
      } else {
        conn.fetchUserInfoById(val).then((res) => {
          const firstKey = Object.keys(res.data)[0];
          let userInfo = {
            avatar:
              res.data[firstKey].avatarurl != ""
                ? res.data[firstKey].avatarurl
                : require("@/assets/imgs/headImg.png"),
            name: res.data[firstKey].nickname,
            unReadNum: 1,
            maniacCode: val,
            memberType:
              res.data[firstKey].ext == "保安"
                ? 2
                : res.data[firstKey].ext == "保安公司员工"
                ? 4
                : res.data[firstKey].ext == "保安公司"
                ? 3
                : res.data[firstKey].ext == "客户公司" ||
                  res.data[firstKey].ext == "客户个人"
                ? 1
                : 1,
          };
          this.userList.unshift(userInfo);
        });
      }
    },
    // 集成收到文本信息方法
    getMessage() {
      let that = this;
      conn.listen({
        onOpened: function (message) {
          console.log("用户已上线"); // 连接成功
        },
        // onError: function(message) {
        //   console.log("连接失败", message); // 连接失败
        //   console.log("用户已下线"); // 连接关闭
        // },
        onTextMessage: function (message) {
          console.log("收到文本消息", message);
          let value = {};
          let time = that.getTime(message.time);
          let obj = {
            context: message.data,
            type: 0,
            jobNo: "",
          };
          value = {
            msgType: "text",
            info: obj,
            to: message.to,
            from: message.from,
            time: time,
            new: 1,
          };
          that.saveMessage(message.from, value);
        },
        onPictureMessage: function (message) {
          console.log("收到图片消息", message);
          let value = {};
          let time = that.getTime(message.time);
          let obj = {
            context: message.url,
            type: 1,
            jobNo: "",
          };
          value = {
            msgType: "text",
            info: obj,
            to: message.to,
            from: message.from,
            time: time,
            new: 1,
          };
          that.saveMessage(message.from, value);
        },
        onCustomMessage: function (message) {
          let time = that.getTime(message.time);
          let value = {};
          let obj = {
            context: message.url,
            type: "",
            jobNo: "",
          };
          if (message.customEvent == "eventComplaint") {
            console.log("收到投诉消息", message);
            obj.type = 8; // 投诉
            obj.jobComplainId = message.customExts.id; // 投诉id
            obj.complainNo = message.customExts.complainNo; // 投诉编号
            obj.jobComplainStatus = message.customExts.status; // 投诉状态
            obj.jobName = message.customExts.jobTitle; // 任务名称
            obj.respondentName = message.customExts.bodyguardName; // 被投诉人名称
            obj.complainantName = message.customExts.creatorName; // 投诉人名称
            obj.complainMemo = message.customExts.complainMemo; // 投诉人名称
            obj.submitAt = that.getTime(message.time); // 投诉人名称
          } else if (message.customEvent == "eventBreach") {
            console.log("收到违约消息", message);
            obj.type = 9; // 违约
            obj.violateLogNo = message.customExts.violateLogNo; // 违约编号
            obj.violateLogStatus = message.customExts.violateLogStatus; // 违
            obj.jobName = message.customExts.jobName; // 任务名称
            obj.matterMemo = message.customExts.voilateMemo; // 任务名称
            obj.voilateTypeTitle = message.customExts.voilateTypeTitle; // 违约类型
            obj.violateAmount = message.customExts.violateAmount || 0; // 违约金额
            obj.refundAmount = message.customExts.refundAmount || 0; // 退还金额
            obj.violateLogId = message.customExts.id; // 违
          } else if (message.customEvent == "eventOrder") {
            console.log("收到任务消息", message);
            obj.type = 7; // 任务
            obj.id = message.customExts.jobId; // 任务ID
            obj.jobNo = message.customExts.jobNo; // 任务编号
            obj.status = message.customExts.status; // 任务状态
            obj.jobName = message.customExts.title; // 任务名称
            obj.address =
              message.customExts.province +
              message.customExts.city +
              message.customExts.address +
              "-" +
              message.customExts.buildName; // 任务地址
            obj.jobStart = message.customExts.jobStart; // 任务开始时间
            obj.jobEnd = message.customExts.jobEnd; // 任务结束时间
            obj.unitPrice = message.customExts.incomeTask; // 任务单价
            obj.hour = message.customExts.hour; // 任务单价
            obj.price = message.customExts.incomeTotal; // 任务单价
          } else {
            obj.type = 10; // 考勤
            console.log("收到考勤消息", message);
            obj.operateStatusTitle = message.customExts.operateStatusTitle; // 考勤申诉状态
            obj.signStatusTitle = message.customExts.signStatusTitle; // 考勤打卡状态
            obj.appealNo = message.customExts.appealNo; // 考勤编号
            obj.appealId = message.customExts.id; // 考勤ID
            obj.jobName = message.customExts.jobTitle; // 任务名称
            obj.appealReason = message.customExts.appealReason; // 任务名称
            obj.dueAtIn = message.customExts.dueAtIn; // 任务名称
            obj.dueAtOut = message.customExts.dueAtOut; // 任务名称
          }
          value = {
            msgType: "text",
            info: obj,
            to: message.to,
            from: message.from,
            time: time,
            new: 1,
          };
          that.saveMessage(message.from, value);
        },
      });
    },
    getTime(val) {
      var dateObj = new Date();
      var year = dateObj.getFullYear();
      var month = dateObj.getMonth() + 1; // 注意月份从0开始计算，所以需要加1
      if (month < 10) {
        month = "0" + month;
      }
      var day = dateObj.getDate();
      var hours = dateObj.getHours();
      var minutes = dateObj.getMinutes();
      var seconds = dateObj.getSeconds();
      let time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      console.log(time, "时间");
      return time;
    },
    //处理数据
    handleData(val) {
      let arr = this.messageList;
      for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i].info == "string") {
          if (arr[i].info.indexOf("\\n") != -1) {
            arr[i].info = arr[i].info.replace(/[\n]/g, "");
            try {
              let obj = JSON.parse(arr[i].info);
              arr[i].info = obj;
            } catch (error) {}
          } else {
            try {
              let obj = JSON.parse(arr[i].info);
              arr[i].info = obj;
            } catch (error) {}
          }
        }
        if (arr[i].info.type == 9) {
          let num =
            arr[i].info.violateAmount * 1 + arr[i].info.cancelAmount * 1;
          arr[i].info.money = (arr[i].info.price * 1 - num * 1).toFixed(2);
        }
        if (arr[i].info.type == 8) {
          if (arr[i].info.submitAt) {
            arr[i].info.submitAt = arr[i].info.submitAt.replace(/[T]/g, " ");
          }
        }
        if (arr[i].info.type == 7) {
          arr[i].info.jobStart = arr[i].info.jobStart.replace(/[T]/g, " ");
          arr[i].info.jobEnd = arr[i].info.jobEnd.replace(/[T]/g, " ");
        }
        arr[i].time = arr[i].time.replace(/[T]/g, " ");
      }
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = 0; j < arr.length - i - 1; j++) {
          // 1.对每一个值和它的下一个值进行比较
          if (arr[j].id > arr[j.id + 1]) {
            // 如果第一个值更多，则将其赋予自定义计数值 count
            var count = arr[j].id;
            // 反复交换
            arr[j].id = arr[j.id + 1];
            arr[j.id + 1] = count;
          }
        }
      }
      this.messageList = arr;
      if (val == "new") {
        this.$nextTick(() => {
          let scrollEl = this.$refs.mianscroll;
          scrollEl.scrollTo({
            top: scrollEl.scrollHeight,
            behavior: "smooth",
          });
        });
      }
      this.geted();
    },
  },
};
</script>
<style scoped>
.boxContent {
  display: flex;
  border: 1px solid #ccc;
}
.chat {
  height: 60vh;
  /* overflow-y: scroll; */
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  background: #f5f7fa;
}
.send {
  height: 150px;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  border-top: 1px solid #ccc;
  justify-content: end;
}
.noSend {
  height: 77vh;
}
.btn {
  width: 80px;
  height: 30px;
  line-height: 24px;
  margin-left: 30px;
  margin-top: 80px;
  border-radius: 6px;
  font-size: 14px;
}
.listTile {
  padding: 20px 10px;
  box-sizing: border-box;
  background: #165dff;
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}
.userItem {
  cursor: pointer;
  padding: 20px 15px;
  box-sizing: border-box;
  border-bottom: #ccc 1px solid;
  display: flex;
  align-items: center;
  position: relative;
}
.ueserSelect {
  background: #9cb3eb;
  color: #fff;
}
.userImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  flex: none;
}
.userImg img {
  width: 100%;
  height: 100%;
}
.num {
  height: 20px;
  flex: none;
  text-align: center;
  border-radius: 8px;
  padding: 0 6px;
  background: red;
  box-sizing: border-box;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  top: 10px;
  left: 30px;
}
.chatItem {
  width: 100%;
  margin: 20px 0;
}
.userInfo {
  display: flex;
  align-items: center;
}
.userInfo1 {
  display: flex;
  align-items: center;
  justify-content: end;
}
.chatImg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
}
.chatImg img {
  width: 100%;
  height: 100%;
}
.userchat {
  padding-left: 60px;
  box-sizing: border-box;
  margin-top: 10px;
}
.userchat1 {
  display: flex;
  justify-content: end;
  padding-right: 60px;
  box-sizing: border-box;
  margin-top: 10px;
}
.box-card {
  max-width: 400px;
  background: #fff;
  padding: 10px 10px;
  height: auto;
  border-radius: 8px;
  overflow-wrap: anywhere;
  display: inline-block;
}
.other {
  background: #dff1ff;
}
.box-card img {
  width: 200px;
  height: 200px;
}
.box-card1 {
  width: 400px;
  font-size: 12px;
  color: #165dff;
}
.cardTop {
  display: flex;
  justify-content: space-between;
  justify-items: center;
}
.cardStatus {
  padding: 1px 2px;
  color: rgb(43, 233, 169);
  border: 1px solid rgb(43, 233, 169);
  font-size: 12px;
}
.cardNum {
  color: rgb(240, 176, 27);
}
.pointer {
  cursor: pointer;
}
</style>
